// extracted by mini-css-extract-plugin
module.exports = {"footer":"layout-module--footer--Qriki","list":"layout-module--list--1yLp4","layoutDiv":"layout-module--layoutDiv--1msHl"};